import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CalendarView } from 'angular-calendar';

@Component({
  selector: 'app-calendar-header',
  template: `
  <div class="row text-center">
    <div class="ml-3">
    <nav>
      <ul class="pagination pagination-circle pg justify-content-center">
        <li
             class="page-item">
          <a class="page-link" (click)="previousMonth.emit()">Previous</a>
        </li>
        <li
             class="page-item active">
          <a class="page-link" (click)="currentMonth.emit()">Today</a>
        </li>
        <li

             class="page-item" class="page-item">
          <a class="page-link" (click)="nextMonth.emit()">Next</a>
        </li>
      </ul>
    </nav>
  </div>
      <div class="col-md-4">
        <h3>{{ viewDate | calendarDate: view + 'ViewTitle':locale }}</h3>
      </div>
    </div>
    <br />
  `,
})
export class CalendarHeaderComponent {
  @Output() nextMonth = new EventEmitter();

  @Output() previousMonth = new EventEmitter();

  @Output() currentMonth = new EventEmitter();

  @Input() view: CalendarView | 'month' | 'week' | 'day';

  @Input() viewDate: Date;

  @Input() locale = 'en';

  @Output() viewChange: EventEmitter<string> = new EventEmitter();

  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();
}
